// De tabbladen Kaartje en Foto's, en een eenvoudige lightbox (<dialog>, pijltjes en Esc).
import type { ListResponse } from '../shared/api-types.ts';
import { $, h } from './dom.ts';
import { icon } from './icons.ts';

type Photo = ListResponse['photos'][number];

let photos: Photo[] = [];
let index = 0;
const rendered = new Map<string, string>();

/** Slaat opnieuw tekenen over als de inhoud niet veranderde (de lijst ververst elke minuut). */
function unchanged(viewId: string, data: unknown): boolean {
  const key = JSON.stringify(data);
  if (rendered.get(viewId) === key) return true;
  rendered.set(viewId, key);
  return false;
}

export function renderCards(cards: ListResponse['cards']): void {
  if (unchanged('cardView', cards)) return;
  const view = $('cardView');
  view.replaceChildren(h('div', { class: cards.length > 1 ? 'kaartjes two' : 'kaartjes' },
    cards.map((c, i) => h('img', {
      class: 'kaartje', src: c.url, loading: i === 0 ? 'eager' : 'lazy',
      alt: cards.length > 1 ? `Geboortekaartje, kant ${i + 1}` : 'Geboortekaartje',
    }))));
}

export function renderPhotos(list: Photo[]): void {
  photos = list;
  if (unchanged('photoView', list)) return;
  $('photoView').replaceChildren(h('ul', { class: 'photos' }, list.map((p, i) => {
    const label = p.caption ? `Bekijk foto: ${p.caption}` : `Bekijk foto ${i + 1}`;
    const btn = h('button', { type: 'button', class: 'photo', 'aria-label': label },
      h('img', { src: p.url, alt: '', loading: 'lazy' }));
    btn.addEventListener('click', () => openLightbox(i));
    return h('li', null, h('figure', null, btn, p.caption ? h('figcaption', { text: p.caption }) : null));
  })));
}

function lightbox(): HTMLDialogElement {
  return $('lightbox') as HTMLDialogElement;
}

function showPhoto(): void {
  const p = photos[index];
  if (!p) return;
  const many = photos.length > 1;
  const counter = many ? `${index + 1} / ${photos.length}` : '';
  $('lbBody').replaceChildren(
    h('img', { class: 'lbimg', src: p.url, alt: p.caption || `Foto ${index + 1}` }),
    h('p', { class: 'lbcap' }, h('span', { text: p.caption }), counter ? h('span', { class: 'lbcount', text: counter }) : null));
  $('lbPrev').hidden = !many;
  $('lbNext').hidden = !many;
}

function step(delta: number): void {
  index = (index + delta + photos.length) % photos.length;
  showPhoto();
}

function openLightbox(i: number): void {
  index = i;
  showPhoto();
  const dlg = lightbox();
  if (!dlg.open) dlg.showModal();
}

export function closeLightbox(): void {
  const dlg = lightbox();
  if (dlg.open) dlg.close();
}

export function initLightbox(): void {
  const dlg = lightbox();
  $('lbPrev').append(icon('left'));
  $('lbNext').append(icon('right'));
  $('lbClose').append(icon('close'));
  $('lbPrev').addEventListener('click', () => step(-1));
  $('lbNext').addEventListener('click', () => step(1));
  $('lbClose').addEventListener('click', closeLightbox);
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) closeLightbox();
  });
  dlg.addEventListener('keydown', (e) => {
    if (photos.length < 2) return;
    if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
}
